import { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { UserEntity } from "@lifeat/shared/data-models/user/UserEntity";
import { Routes } from "@lifeat/shared/system/RouteConstants";
import { callMonolith } from "@service/ServerlessFunctionsService";
import { buildRoute } from "@util/RouteUtil";
import { AdminError } from "../../features/admin/AdminError";
import { AdminUserControls } from "../../features/admin/AdminUserControls";
import LoadingView from "../../features/virtual-space/components/SpaceView/LoadingView/LoadingView";

type State =
    | {
          type: "loading";
      }
    | {
          type: "loaded";
          uid: string;
          userData: UserEntity;
      }
    | {
          type: "error";
          message: string;
      };

export function AdminUserByUidPage() {
    const [state, setState] = useState<State>({ type: "loading" });
    const match = useRouteMatch<Record<"uid", string>>(buildRoute(Routes.AdminUserByUid, ":uid"));

    useEffect(() => {
        setState({ type: "loading" });

        callMonolith("admin-get-user-by-uid", { uid: decodeURIComponent(match.params.uid) })
            .then((res) => {
                if (res) {
                    setState({ type: "loaded", uid: res.uid, userData: res.userData });
                } else {
                    setState({ type: "error", message: "User not found" });
                }
            })
            .catch((e) => setState({ type: "error", message: String(e) }));
    }, [match.params.uid]);

    if (state.type === "loading") {
        return <LoadingView isAppLoading />;
    }
    if (state.type === "error") {
        return <AdminError message={state.message} />;
    }
    return <AdminUserControls uid={state.uid} userData={state.userData} />;
}
